import * as React from "react"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import sidebarStyle from "../../assets/jss/material-dashboard-pro-react/components/sidebarStyle.jsx";

import cx from "classnames";
import avatarDefault from "../../assets/img/default-avatar.png";

class User extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            openAvatar: false
        };
    }

    render() {
        const avatar = this.props.userAvatarUrl ? this.props.userAvatarUrl : avatarDefault;
        const headerMainText = this.props.headerMainText || '';
        const headerSubText = this.props.headerSubText || '';
        const { classes } = this.props;
        const photo = classes.photo;
        const itemText = classes.itemText + " " + cx({ [classes.itemTextMini]: this.props.miniActive && this.state.miniActive });

        return (
            <div className='user-name-section' onClick={this.props.handleClick}>
                <div className='user-name-label'>
                    <label className={itemText + ' ' + classes.userItemText}>{headerMainText}</label>
                    <label className={itemText + ' ' + classes.userItemText + ' ' + 'user-ItemSubText'}>{headerSubText}</label>
                </div>
                <div className={photo}>
                    <img src={avatar} className={classes.avatarImg} alt="..." />
                </div>
            </div>
        );
    }
}

export default withStyles(sidebarStyle)(User);
